import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CreateShipTypeDuration from "../../components/ShipmentDuration/CreateShipTypeDuration";
// import CreateShipTypeDuration from "../../components/ShipmentDuration/CreateShiptypeDuration";

// import CreateShipTypeDuration from "../../components/ShipmentDuration/CreateShipTypeDuration";

const CreateShipTypeDurationPage = () => {
    return (
        <>

            <MasterLayout>

                <Breadcrumb title="Create Shipment Duration" subtitle={"Shipment Duration"} subUrl={"shipment-duration"} />
           
                {/* <CreateShipTypeDuration /> */}
                <CreateShipTypeDuration/>



            </MasterLayout>
        </>
    );
};

export default CreateShipTypeDurationPage;
